import { useEffect, useState } from "react";
import { ComposableMap, Geographies, Geography } from "react-simple-maps";
import { scaleLinear } from "d3-scale";

// US topojson (atlas) URL from world-atlas
const US_TOPO = "https://cdn.jsdelivr.net/npm/us-atlas@3/states-10m.json";

// Map of full state name to USPS code (since topojson uses full names)
const NAME_TO_CODE = {
  "Alabama": "AL", "Alaska": "AK", "Arizona": "AZ", "Arkansas": "AR", "California": "CA",
  "Colorado": "CO", "Connecticut": "CT", "Delaware": "DE", "Florida": "FL", "Georgia": "GA",
  "Hawaii": "HI", "Idaho": "ID", "Illinois": "IL", "Indiana": "IN", "Iowa": "IA",
  "Kansas": "KS", "Kentucky": "KY", "Louisiana": "LA", "Maine": "ME", "Maryland": "MD",
  "Massachusetts": "MA", "Michigan": "MI", "Minnesota": "MN", "Mississippi": "MS", "Missouri": "MO",
  "Montana": "MT", "Nebraska": "NE", "Nevada": "NV", "New Hampshire": "NH", "New Jersey": "NJ",
  "New Mexico": "NM", "New York": "NY", "North Carolina": "NC", "North Dakota": "ND", "Ohio": "OH",
  "Oklahoma": "OK", "Oregon": "OR", "Pennsylvania": "PA", "Rhode Island": "RI", "South Carolina": "SC",
  "South Dakota": "SD", "Tennessee": "TN", "Texas": "TX", "Utah": "UT", "Vermont": "VT",
  "Virginia": "VA", "Washington": "WA", "West Virginia": "WV", "Wisconsin": "WI", "Wyoming": "WY",
};

export default function GeoHeatMap({ data = [] }) {
  // data: [{state: "AZ", count: 5}, ...]
  const [hover, setHover] = useState(null);
  const counts = Object.fromEntries(data.map((d) => [d.state, d.count]));
  const max = Math.max(1, ...data.map((d) => d.count));
  const color = scaleLinear().domain([0, max]).range(["#0E1116", "#10B981"]);

  return (
    <div className="relative" data-testid="geo-heatmap">
      <ComposableMap projection="geoAlbersUsa" projectionConfig={{ scale: 900 }} width={780} height={420} style={{ width: "100%", height: "auto" }}>
        <Geographies geography={US_TOPO}>
          {({ geographies }) =>
            geographies.map((geo) => {
              const name = geo.properties.name;
              const code = NAME_TO_CODE[name];
              const c = counts[code] || 0;
              return (
                <Geography
                  key={geo.rsmKey}
                  geography={geo}
                  fill={c > 0 ? color(c) : "#0E1116"}
                  stroke="#1F2937"
                  strokeWidth={0.5}
                  onMouseEnter={() => setHover({ name, code, count: c })}
                  onMouseLeave={() => setHover(null)}
                  style={{
                    default: { outline: "none" },
                    hover: { outline: "none", fill: "#34D399", cursor: "pointer" },
                    pressed: { outline: "none" },
                  }}
                />
              );
            })
          }
        </Geographies>
      </ComposableMap>

      {hover && (
        <div className="absolute top-2 left-2 bg-[#0A0D12] border border-white/10 rounded-sm px-3 py-1.5 text-xs">
          <div className="font-medium">{hover.name} ({hover.code})</div>
          <div className="font-mono text-emerald-400 tabular-nums">{hover.count} opportunities</div>
        </div>
      )}

      <div className="flex items-center justify-end gap-2 text-[10px] uppercase tracking-widest text-slate-500 mt-2">
        <span>Low</span>
        <div className="h-2 w-32 rounded-sm" style={{ background: "linear-gradient(to right, #0E1116, #10B981)" }} />
        <span>High</span>
      </div>
    </div>
  );
}
